var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMiniBag = function SvgIconMiniBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4440",
    d: "M7.346 23.15a1.97 1.97 0 0 1-1.446-.595 1.97 1.97 0 0 1-.595-1.446q0-.85.595-1.446a1.97 1.97 0 0 1 1.446-.596q.851 0 1.446.596.596.595.596 1.446 0 .85-.596 1.446t-1.446.596m11.308 0q-.851 0-1.446-.595a1.97 1.97 0 0 1-.596-1.446q0-.85.596-1.446.595-.596 1.446-.596.85 0 1.446.596.595.595.595 1.446 0 .85-.595 1.446a1.97 1.97 0 0 1-1.446.596M5.179 2.959h16.199q.715 0 1.082.61.366.609.035 1.244l-3.738 6.77a2.1 2.1 0 0 1-.76.787q-.472.282-1.035.282H8.45L7.1 15.118q-.09.136-.006.292a.27.27 0 0 0 .252.157h13.35v1.75H7.345q-1.167 0-1.753-1.006-.586-1.005-.042-2.01l1.665-2.992-4.245-8.934H.75V.625h3.32z"
  })));
};
export default SvgIconMiniBag;